export interface DomainInfo {
  id: string;
  code: string;
  name: string;
}

export const MATH_DOMAINS: DomainInfo[] = [
  { id: 'domain-001', code: 'CC', name: 'Counting and Cardinality' },
  { id: 'domain-002', code: 'OA', name: 'Operations and Algebraic Thinking' },
  { id: 'domain-003', code: 'NBT', name: 'Number and Operations in Base Ten' },
  { id: 'domain-004', code: 'NF', name: 'Number and Operations—Fractions' },
  { id: 'domain-005', code: 'MD', name: 'Measurement and Data' },
  { id: 'domain-006', code: 'G', name: 'Geometry' },
  { id: 'domain-007', code: 'RP', name: 'Ratios and Proportional Relationships' },
  { id: 'domain-008', code: 'NS', name: 'The Number System' },
  { id: 'domain-009', code: 'EE', name: 'Expressions and Equations' },
  { id: 'domain-010', code: 'SP', name: 'Statistics and Probability' },
  { id: 'domain-011', code: 'F', name: 'Functions' },
  { id: 'domain-012', code: 'NQ', name: 'Number and Quantity' },
  { id: 'domain-013', code: 'A', name: 'Algebra' },
  { id: 'domain-014', code: 'M', name: 'Modeling' }
];

export type MathDomain = typeof MATH_DOMAINS[number]['name'];

// Helper function to find a domain by name
export const getDomainByName = (name: string): DomainInfo | undefined => {
  return MATH_DOMAINS.find(domain => domain.name === name);
};

// Helper function to find a domain by code
export const getDomainByCode = (code: string): DomainInfo | undefined => {
  return MATH_DOMAINS.find(domain => domain.code === code);
};

// Helper function to find a domain by id
export const getDomainById = (id: string): DomainInfo | undefined => {
  return MATH_DOMAINS.find(domain => domain.id === id);
};
